import { CompanyDepositProvisionalType } from '../../../types/resources/CompanyDepositType';
import { fetchWrapper } from '../../fetchWrapper';

type GetResponseType = {
  data: {
    company_deposit_provisional: CompanyDepositProvisionalType;
  };
  headers: Record<string, string>;
};

export const getCompanyDepositsProvisional = async (
  signOut: () => void
): Promise<GetResponseType> => {
  const response = await fetchWrapper(
    '/company_deposits/provisional',
    {
      method: 'GET',
    },
    signOut
  );

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  return {
    data,
    headers: Object.fromEntries(response.headers.entries()),
  };
};
